import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { ScanBarcodeComponent } from './component/scan-barcode.component';
import { CommonLayoutModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from '../centered-scrollable-content/centered-scrollable-content.module';



@NgModule({
  declarations: [
    ScanBarcodeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CenteredScrollableContentModule,
    CommonLayoutModule,
    CommonTranslationModule

  ]
})
export class ScanBarcodeModule { }
